import { graphql } from '@graphql/__generated'

export const GET_USER_STATUS = graphql(`
  query getUserStatus($email: String!) {
    getUserStatus(email: $email) {
      exists
    }
  }
`)
